/* V2 fork of biw-ck-look-v1.js: adds the worksheet preview (third image) to the
 * Look Inside filmstrip. Everything else is unchanged.
 *
 * CLEAR Kit PDP, "Look inside a section" filmstrip + sticky buy bar.
 *
 * Deliberately touches NOTHING in the purchase path. It never reads, writes,
 * clears or submits the product form, and it never goes near the option app's
 * fields (.tcustomizer__text-field) or the "Do not personalize" block. The
 * sticky bar and repeat CTA scroll the buyer back to the real form and focus
 * it; they do not proxy-submit, so option-app validation still shows where the
 * buyer can see it.
 *
 * IntersectionObserver is used where available but always paired with an
 * interval fallback: the in-app preview browser used for review does not
 * deliver async observer callbacks, and code that relies on them alone looks
 * broken there while working fine in a real browser.
 */
(function () {
  'use strict';

  /* ---------------- look-inside filmstrip ---------------- */
  function initLook() {
    var root = document.querySelector('[data-biwlook]');
    if (!root) return;
    var front = root.querySelector('[data-biwlook-front]');
    var back = root.querySelector('[data-biwlook-back]');
    var ws = root.querySelector('[data-biwlook-ws]');
    var nameEl = root.querySelector('[data-biwlook-name]');
    var numEl = root.querySelector('[data-biwlook-num]');
    var btns = root.querySelectorAll('.biwlook__num');
    if (!front || !back || !btns.length) return;

    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(btns, function (o) {
          o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
        });
        var name = b.getAttribute('data-name') || '';
        front.src = b.getAttribute('data-front');
        back.src = b.getAttribute('data-back');
        if (ws && b.getAttribute('data-ws')) { ws.src = b.getAttribute('data-ws'); ws.alt = 'First worksheet page for ' + name + ', preview'; }
        // Alt text has to move with the image or a screen reader is left
        // describing whichever section happened to render first.
        front.alt = 'CLEAR Kit guided tab, front, for ' + name;
        back.alt = 'CLEAR Kit guided tab, back, for ' + name;
        if (nameEl) nameEl.textContent = name;
        if (numEl) numEl.textContent = b.getAttribute('data-n');
      });
    });
  }

  /* ---------------- scroll back to the real buy form ---------------- */
  function buyTarget() {
    return document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
  }

  function goToBuy() {
    var form = buyTarget();
    if (!form) return;
    var btn = form.querySelector('[name="add"]');
    try {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      form.scrollIntoView();
    }
    if (btn) {
      // Focus after the smooth scroll settles, so the browser does not fight it.
      setTimeout(function () {
        try { btn.focus({ preventScroll: true }); } catch (e2) { btn.focus(); }
      }, 520);
    }
  }

  function initCta() {
    var els = document.querySelectorAll('[data-biw-gotobuy]');
    Array.prototype.forEach.call(els, function (el) {
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        goToBuy();
      });
    });
  }

  /* ---------------- sticky buy bar ---------------- */
  function initBar() {
    var bar = document.querySelector('[data-biwbar]');
    var form = buyTarget();
    if (!bar || !form) return;

    var priceEl = document.querySelector('.price__container .price-item--regular')
      || document.querySelector('.price__container .price-item')
      || document.querySelector('.price__container');
    var out = bar.querySelector('[data-biwbar-price]');

    function syncPrice() {
      if (!out || !priceEl) return;
      var t = (priceEl.textContent || '').replace(/\s+/g, ' ').trim();
      if (t && t !== out.textContent) out.textContent = t;
    }

    function shouldShow() {
      var r = form.getBoundingClientRect();
      // Show once the real buy form has scrolled past, hide again near the foot
      // of the page so the bar never sits on top of the footer CTA.
      var pastForm = r.bottom < 0;
      var nearEnd = (window.innerHeight + window.scrollY)
        > (document.documentElement.scrollHeight - 220);
      return pastForm && !nearEnd;
    }

    var shown = null;
    function update() {
      var want = shouldShow();
      if (want !== shown) {
        shown = want;
        bar.setAttribute('data-show', want ? 'true' : 'false');
        bar.setAttribute('aria-hidden', want ? 'false' : 'true');
      }
      syncPrice();
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    // Belt and braces: covers variant swaps that rewrite the price node, and
    // any environment where the scroll listener is throttled or absent.
    setInterval(update, 700);
    update();
  }

  function boot() {
    initLook();
    initCta();
    initBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
